interface User {
    id: string
    name: string
    email: string
    password: string
    role: 'manager' | 'employee'
    companyId?: string
  }
  interface Company {
    id: string
    name: string
    phone: string
    address: string
    ownerId: string
  }
  interface Material {
    id: string
    name: string
    category: string
    unit: string
    bigStockQuantity: number
    subStockQuantity: number
    lowStockThreshold: number
    description: string
    image: string
    status: 'In Stock' | 'Low Stock' | 'Out of Stock'
  }
  interface Transaction {
    id: string
    materialId: string
    type: 'transfer' | 'sale'
    quantity: number
    stock: 'Big Stock' | 'Sub Stock'
    date: string
    status: 'Pending' | 'Approved'
}
export const localStorageService = {
  getUsers (): User[] {
    return JSON.parse(localStorage.getItem('users') || '[]')
  },
  setUsers (users: User[]): void {
    localStorage.setItem('users', JSON.stringify(users))
  },
  getCurrentUser (): User | null {
    return JSON.parse(localStorage.getItem('currentUser') || 'null')
  },
  setCurrentUser (user: User): void {
    localStorage.setItem('currentUser', JSON.stringify(user))
  },
  getCompanies (): Company[] {
    return JSON.parse(localStorage.getItem('companies') || '[]')
  },
  setCompanies (companies: Company[]): void {
    localStorage.setItem('companies', JSON.stringify(companies))
  },
  getCurrentCompany (): Company | null {
    return JSON.parse(localStorage.getItem('currentCompany') || 'null')
  },
  setCurrentCompany (company: Company): void {
    localStorage.setItem('currentCompany', JSON.stringify(company))
  },
  getMaterials (): Material[] {
    return JSON.parse(localStorage.getItem('materials') || '[]')
  },
  setMaterials (materials: Material[]): void {
    localStorage.setItem('materials', JSON.stringify(materials))
  },
  getTransactions (): Transaction[] {
    return JSON.parse(localStorage.getItem('transactions') || '[]')
  },
  setTransactions (transactions: Transaction[]): void {
    localStorage.setItem('transactions', JSON.stringify(transactions))
  },
  clearAll (): void {
    localStorage.removeItem('users')
    localStorage.removeItem('currentUser')
    localStorage.removeItem('companies')
    localStorage.removeItem('currentCompany')
    localStorage.removeItem('materials')
    localStorage.removeItem('transactions')
  }
}
